import { render } from "./MenuGroupItemModal.vue?vue&type=template&id=eff2e5be&scoped=true"
import script from "./MenuGroupItemModal.vue?vue&type=script&lang=js"
export * from "./MenuGroupItemModal.vue?vue&type=script&lang=js"

import "./MenuGroupItemModal.vue?vue&type=style&index=0&id=eff2e5be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eff2e5be"]])

export default __exports__